import { message } from 'antd'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useMount } from 'react-use'

export interface ValidInfoProps {
  token: string
  authenticate: string
}

interface CaptchaProps {
  beforeStart?: (next: () => void) => void
  onSuccess: (validInfo: ValidInfoProps) => void
  captchaId?: string
  value?: number
  className?: string | undefined
}

const StyledCaptcha = styled.span`
  .captcha-label {
    cursor: pointer;
    &:hover {
      color: ${props => props.theme.primary};
    }
  }
`

export const Captcha: React.FC<CaptchaProps> = ({
  onSuccess,
  beforeStart,
  captchaId = 'get-captcha',
  value = 60,
  className = undefined,
}) => {
  const [isCountStart, setIsCountStart] = useState(false)
  const [counter, setCounter] = useState(value)

  useMount(() => {
    require('~/plugins/yunpian')

    new YpRiddler({
      expired: 10,
      mode: 'dialog',
      noButton: true,
      winWidth: 400,
      lang: 'zh-cn',
      container: document.getElementById(captchaId),
      appId: '0e790ca2c37d4b3c9aaab7ac0032ea06',
      version: 'v1',
      onError: function (param: { code: number }) {
        message.destroy()
        if (!param.code) {
          message.error('错误请求')
        } else if (Math.floor(param.code / 100) == 5) {
          // 服务不可用时，开发者可采取替代方案
          message.error('验证服务暂不可用')
        } else if (param.code == 429) {
          message.error('请求过于频繁，请稍后再试')
        } else {
          message.error('验证失败，请重试')
        }
      },
      onSuccess: function (validInfo: ValidInfoProps, close: () => void) {
        onSuccess(validInfo)
        setIsCountStart(true)
        close()
      },
      onFail: function (code: number, msg: string, retry: () => void) {
        retry()
      },
      beforeStart: function (next: () => void) {
        if (typeof beforeStart === 'function') {
          beforeStart(next)
        } else {
          next()
        }
      },
    })
  })

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>
    if (isCountStart) {
      timer = setInterval(() => {
        if (counter > 1) {
          setCounter(counter => counter - 1)
        } else {
          setIsCountStart(false)
          setCounter(value)
          clearInterval(timer)
        }
      }, 1000)
    }

    return () => {
      clearInterval(timer)
    }
  }, [isCountStart, counter, value])

  return (
    <StyledCaptcha id={captchaId} className={className}>
      {isCountStart ? (
        <span className="captcha-counter">{counter}s</span>
      ) : (
        <span className="captcha-label">获取验证码</span>
      )}
    </StyledCaptcha>
  )
}
